export default class AJVStub {
  // eslint-disable-next-line class-methods-use-this
  validateSchema(): boolean {
    return true
  }

  // eslint-disable-next-line class-methods-use-this
  defaultMeta(): undefined {
    // This is a stub
  }
}
